export const SUPPORTS_OBJECT_GET_PROTOTYPE_OF = "getPrototypeOf" in Object;
